import React from 'react';

const ModalMenuSecondary = () => {
    return (
        <div className="modal-text order-1 order-sm-0 order-md-0 order-lg-0 order-xl-0">
            <p>1785 State Hwy 26, Suite 200 <br/>Grapevine, TX 76051</p>

            <p>
                <a href="tel:+43253312523">+1 914 265 5072</a><br/>
                <a href="mailto:info@domain.com">hello@z3info.com</a>
            </p>
        </div>
    );
};

export default ModalMenuSecondary;
